import { CustomError } from './error'

export class UndefinedEntityError extends CustomError {
  constructor(entity: string, functionName?: string) {
    super(`${entity.toUpperCase()} IS UNDEFINED`, functionName)
  }
}
